(function () {
  'use strict';

  var CONFIG = {
    cutoffHour: 15,
    transitDaysDefault: 1,
    unknownTransitDays: 2,
    maxDaysAfterMin: 2,
    closedDates: []
  };

  var ALL_TIME_SLOTS = ['午前中', '14-16時', '16-18時', '18-20時', '19-21時'];
  var PM_TIME_SLOTS = ['14-16時', '16-18時', '18-20時', '19-21時'];

  var PROVINCE_TRANSIT = {
    'JP-13': 1,
    'JP-14': 1,
    'JP-11': 1,
    'JP-12': 1,
    'JP-08': 1,
    'JP-09': 1,
    'JP-10': 1,
    'JP-19': 1,
    'JP-20': 1,
    'JP-15': 1,
    'JP-22': 1,
    'JP-23': 1,
    'JP-21': 1,
    'JP-24': 1,
    'JP-16': 1,
    'JP-17': 1,
    'JP-18': 1,
    'JP-27': 1,
    'JP-26': 1,
    'JP-28': 1,
    'JP-29': 1,
    'JP-25': 1,
    'JP-30': 1,
    'JP-07': 1,
    'JP-04': 1,
    'JP-06': 1,
    'JP-03': 1,
    'JP-02': 1,
    'JP-05': 1,
    'JP-31': 1,
    'JP-32': 1,
    'JP-33': 1,
    'JP-34': 1,
    'JP-36': 1,
    'JP-37': 1,
    'JP-38': 1,
    'JP-39': 1,
    'JP-40': 1,
    'JP-35': 2,
    'JP-41': 2,
    'JP-42': 2,
    'JP-43': 2,
    'JP-44': 2,
    'JP-45': 2,
    'JP-46': 2,
    'JP-01': 2,
    'JP-47': 2
  };

  var AM_RESTRICTED_PROVINCES = [
    'JP-02',
    'JP-05',
    'JP-31',
    'JP-32',
    'JP-33',
    'JP-34',
    'JP-36',
    'JP-37',
    'JP-38',
    'JP-39',
    'JP-40',
    'JP-41',
    'JP-42',
    'JP-43',
    'JP-44',
    'JP-45',
    'JP-46',
    'JP-01',
    'JP-47'
  ];

  var PROVINCE_NAMES = {
    'JP-01': '北海道',
    'JP-02': '青森県',
    'JP-03': '岩手県',
    'JP-04': '宮城県',
    'JP-05': '秋田県',
    'JP-06': '山形県',
    'JP-07': '福島県',
    'JP-08': '茨城県',
    'JP-09': '栃木県',
    'JP-10': '群馬県',
    'JP-11': '埼玉県',
    'JP-12': '千葉県',
    'JP-13': '東京都',
    'JP-14': '神奈川県',
    'JP-15': '新潟県',
    'JP-16': '富山県',
    'JP-17': '石川県',
    'JP-18': '福井県',
    'JP-19': '山梨県',
    'JP-20': '長野県',
    'JP-21': '岐阜県',
    'JP-22': '静岡県',
    'JP-23': '愛知県',
    'JP-24': '三重県',
    'JP-25': '滋賀県',
    'JP-26': '京都府',
    'JP-27': '大阪府',
    'JP-28': '兵庫県',
    'JP-29': '奈良県',
    'JP-30': '和歌山県',
    'JP-31': '鳥取県',
    'JP-32': '島根県',
    'JP-33': '岡山県',
    'JP-34': '広島県',
    'JP-35': '山口県',
    'JP-36': '徳島県',
    'JP-37': '香川県',
    'JP-38': '愛媛県',
    'JP-39': '高知県',
    'JP-40': '福岡県',
    'JP-41': '佐賀県',
    'JP-42': '長崎県',
    'JP-43': '熊本県',
    'JP-44': '大分県',
    'JP-45': '宮崎県',
    'JP-46': '鹿児島県',
    'JP-47': '沖縄県'
  };

  var PROVINCE_CODES_BY_ENGLISH_NAME = {
    hokkaido: 'JP-01', aomori: 'JP-02', iwate: 'JP-03', miyagi: 'JP-04',
    akita: 'JP-05', yamagata: 'JP-06', fukushima: 'JP-07', ibaraki: 'JP-08',
    tochigi: 'JP-09', gunma: 'JP-10', saitama: 'JP-11', chiba: 'JP-12',
    tokyo: 'JP-13', kanagawa: 'JP-14', niigata: 'JP-15', toyama: 'JP-16',
    ishikawa: 'JP-17', fukui: 'JP-18', yamanashi: 'JP-19', nagano: 'JP-20',
    gifu: 'JP-21', shizuoka: 'JP-22', aichi: 'JP-23', mie: 'JP-24',
    shiga: 'JP-25', kyoto: 'JP-26', osaka: 'JP-27', hyogo: 'JP-28',
    nara: 'JP-29', wakayama: 'JP-30', tottori: 'JP-31', shimane: 'JP-32',
    okayama: 'JP-33', hiroshima: 'JP-34', yamaguchi: 'JP-35', tokushima: 'JP-36',
    kagawa: 'JP-37', ehime: 'JP-38', kochi: 'JP-39', fukuoka: 'JP-40',
    saga: 'JP-41', nagasaki: 'JP-42', kumamoto: 'JP-43', oita: 'JP-44',
    miyazaki: 'JP-45', kagoshima: 'JP-46', okinawa: 'JP-47'
  };

  var leadtimeCacheByUrl = {};

  function normalizeZip(value) {
    return String(value || '').replace(/\D/g, '').slice(0, 7);
  }

  function normalizeProvinceCode(pcode) {
    pcode = String(pcode || '').trim();
    if (!pcode) return '';
    if (PROVINCE_TRANSIT[pcode] !== undefined) return pcode;

    var lower = pcode.toLowerCase();
    if (PROVINCE_CODES_BY_ENGLISH_NAME[lower]) return PROVINCE_CODES_BY_ENGLISH_NAME[lower];
    if (pcode === '東京') return 'JP-13';
    if (pcode === '鹿児島') return 'JP-46';
    if (pcode === '沖縄') return 'JP-47';
    for (var code in PROVINCE_NAMES) {
      if (Object.prototype.hasOwnProperty.call(PROVINCE_NAMES, code) && PROVINCE_NAMES[code] === pcode) return code;
    }

    return pcode;
  }

  function getTransitDays(pcode, useSafeUnknown) {
    pcode = normalizeProvinceCode(pcode);
    var fallbackDays = useSafeUnknown ? CONFIG.unknownTransitDays : CONFIG.transitDaysDefault;
    if (!pcode) return fallbackDays;
    var days = PROVINCE_TRANSIT[pcode];
    return (days !== undefined) ? days : fallbackDays;
  }

  function getProvinceName(pcode) {
    return PROVINCE_NAMES[normalizeProvinceCode(pcode)] || null;
  }

  function getJSTNow() {
    var now = new Date();
    return new Date(now.getTime() + (now.getTimezoneOffset() * 60000) + 9 * 3600000);
  }

  function toInputVal(d) {
    var y = d.getFullYear();
    var m = d.getMonth() + 1;
    var day = d.getDate();
    return y + '-' + (m < 10 ? '0' : '') + m + '-' + (day < 10 ? '0' : '') + day;
  }

  var WEEKDAY_JP = ['日', '月', '火', '水', '木', '金', '土'];

  function formatJP(d) {
    return (d.getMonth() + 1) + '月' + d.getDate() + '日（' + WEEKDAY_JP[d.getDay()] + '）';
  }

  function calcShipDate(now) {
    var d = new Date(now);
    if (now.getHours() >= CONFIG.cutoffHour) {
      d.setDate(d.getDate() + 1);
    }
    return d;
  }

  function calcArrivalDate(shipDate, transitDays) {
    var d = new Date(shipDate);
    d.setDate(d.getDate() + transitDays);
    return d;
  }

  function isClosedDate(d) {
    return CONFIG.closedDates.indexOf(toInputVal(d)) >= 0;
  }

  function normalizeSlots(rule) {
    var slots = rule && rule.available_time_slots_on_min_date;
    if (Array.isArray(slots) && slots.length) return slots.slice();
    return rule && rule.am_available_on_min_date === false ? PM_TIME_SLOTS.slice() : ALL_TIME_SLOTS.slice();
  }

  function buildRuleFromParts(parts) {
    var leadDays = Number(parts.lead_days);
    if (!isFinite(leadDays) || leadDays < 1) leadDays = CONFIG.unknownTransitDays;
    return {
      lead_days: leadDays,
      time_rule: parts.time_rule || (leadDays >= 2 ? 'day_after_next_all' : 'next_day_all'),
      am_available_on_min_date: parts.am_available_on_min_date !== false,
      available_time_slots_on_min_date: normalizeSlots(parts),
      notes: parts.notes || '',
      source: parts.source || 'static'
    };
  }

  function fallbackRule(pcode, useSafeUnknown) {
    pcode = normalizeProvinceCode(pcode);
    var leadDays = getTransitDays(pcode, useSafeUnknown);
    var safeUnknown = useSafeUnknown && (!pcode || PROVINCE_TRANSIT[pcode] === undefined);
    var amRestricted = AM_RESTRICTED_PROVINCES.indexOf(pcode) >= 0;
    var amAvailable = !safeUnknown && !(leadDays >= 2 && amRestricted);

    if (safeUnknown) amAvailable = false;

    return buildRuleFromParts({
      lead_days: leadDays,
      time_rule: safeUnknown ? 'safe_unknown' : (leadDays >= 2 ? 'day_after_next_all' : 'next_day_all'),
      am_available_on_min_date: amAvailable,
      available_time_slots_on_min_date: amAvailable ? ALL_TIME_SLOTS : PM_TIME_SLOTS,
      notes: safeUnknown ? 'safe_unknown' : 'legacy_prefecture_fallback',
      source: 'fallback'
    });
  }

  function findFallbackJsonRule(rules) {
    for (var i = 0; i < rules.length; i++) {
      if (rules[i] && rules[i].match_type === 'fallback') return rules[i];
    }
    return null;
  }

  function matchJsonRule(zip, pcode, leadtimeData) {
    var rules = leadtimeData && Array.isArray(leadtimeData.rules) ? leadtimeData.rules : [];
    var normalizedPcode = normalizeProvinceCode(pcode);
    var fullZip = zip && zip.length === 7 ? zip : '';

    if (fullZip) {
      for (var i = 0; i < rules.length; i++) {
        if (rules[i].match_type === 'zip_exact' && String(rules[i].zip || '') === fullZip) return rules[i];
      }
      for (var j = 0; j < rules.length; j++) {
        var prefix5 = String(rules[j].zip_prefix || '');
        if (rules[j].match_type === 'zip_prefix' && prefix5.length === 5 && fullZip.indexOf(prefix5) === 0) return rules[j];
      }
      for (var k = 0; k < rules.length; k++) {
        var prefix3 = String(rules[k].zip_prefix || '');
        if (rules[k].match_type === 'zip_prefix' && prefix3.length === 3 && fullZip.indexOf(prefix3) === 0) return rules[k];
      }
      for (var m = 0; m < rules.length; m++) {
        var prefix2 = String(rules[m].zip_prefix || '');
        if (rules[m].match_type === 'zip_prefix' && prefix2.length === 2 && fullZip.indexOf(prefix2) === 0) return rules[m];
      }
    }

    if (normalizedPcode) {
      for (var l = 0; l < rules.length; l++) {
        if (rules[l].match_type === 'prefecture' && rules[l].prefecture_code === normalizedPcode) return rules[l];
      }
    }

    return findFallbackJsonRule(rules);
  }

  function resolveDeliveryRule(zip, pcode, leadtimeData, useSafeUnknown) {
    var cleanZip = normalizeZip(zip);
    var jsonRule = matchJsonRule(cleanZip, pcode, leadtimeData);
    if (jsonRule) return buildRuleFromParts(jsonRule);
    return fallbackRule(pcode, useSafeUnknown);
  }

  function loadLeadtimeData(url) {
    if (!url || typeof fetch !== 'function') return Promise.resolve(null);
    if (leadtimeCacheByUrl[url]) return leadtimeCacheByUrl[url];

    leadtimeCacheByUrl[url] = fetch(url, { credentials: 'same-origin' })
      .then(function (res) {
        if (!res || !res.ok) return null;
        return res.json();
      })
      .then(function (data) {
        if (!data || !Array.isArray(data.rules)) return null;
        return data;
      })
      .catch(function () {
        return null;
      });

    return leadtimeCacheByUrl[url];
  }

  function initShippingEstimate() {
    var el = document.getElementById('kpw-shipping-estimate');
    if (!el) return;

    try {
      var pcode = el.getAttribute('data-province-code') || '';
      var transitDays = getTransitDays(pcode, false);
      var now = getJSTNow();
      var isBefore = now.getHours() < CONFIG.cutoffHour;
      var arrival = calcArrivalDate(calcShipDate(now), transitDays);

      var badge = '<span class="kpw-se__badge kpw-se__badge--ok">15時までのご注文は当日発送</span>';
      var name = getProvinceName(pcode);
      var regionNote = name
        ? '<span class="kpw-se__region">（' + name + 'へのお届け）</span>'
        : '<span class="kpw-se__region">（関東地方基準）</span>';

      var notes = '';
      if (!isBefore) {
        notes += '<div class="kpw-se__note">※15時以降のご注文は翌日の発送となります</div>';
      }
      notes += '<div class="kpw-se__note">※地域によりお届け日は前後する場合があります</div>';

      el.innerHTML =
        '<div class="kpw-se__inner">' +
          '<div class="kpw-se__status">' + badge + '</div>' +
          '<div class="kpw-se__arrival">最短 <strong>' + formatJP(arrival) + '</strong> 到着予定 ' + regionNote + '</div>' +
          notes +
        '</div>';

      el.removeAttribute('hidden');
    } catch (e) {
      // Keep hidden on rendering errors.
    }
  }

  function saveCartAttribute(key, value) {
    if (!key || typeof fetch !== 'function') return Promise.resolve();
    var body = {};
    body[key] = value;
    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: body })
    });
  }

  function clearInvalidDeliverySelection(state) {
    state.dateInput.value = '';
    if (state.timeSelect) state.timeSelect.value = '';
    updateTimeSlots('', state, state.timeSelect, state.timeAttrKey);
    return queueDeliveryStateSync(state, '', '');
  }

  function isDeliveryDateOutOfRange(state) {
    var val = state.dateInput && state.dateInput.value;
    return !!(val && ((state.minDateStr && val < state.minDateStr) || (state.maxDateStr && val > state.maxDateStr)));
  }

  function refreshDeliveryWindowForCheckout(state) {
    var previousDate = state.dateInput ? state.dateInput.value : '';
    var previousTime = state.timeSelect ? state.timeSelect.value : '';
    applyDeliveryWindow(state.container, state.leadtimeData, state);
    var currentDate = state.dateInput ? state.dateInput.value : '';
    var currentTime = state.timeSelect ? state.timeSelect.value : '';
    var dateInvalidated = !!(previousDate && previousDate !== currentDate);
    var timeInvalidated = !!(previousTime && previousTime !== currentTime);
    if (timeInvalidated && !dateInvalidated) {
      queueDeliveryStateSync(state, currentDate, currentTime);
    }
    return dateInvalidated || timeInvalidated;
  }

  function installCheckoutGuard(form, state) {
    if (!form || form.dataset.kpwDeliveryCheckoutGuarded) return;
    form.dataset.kpwDeliveryCheckoutGuarded = '1';

    form.addEventListener('click', function (e) {
      var target = e.target && e.target.closest ? e.target.closest('[name="checkout"], .cart__checkout, .additional-checkout-buttons, .additional-checkout-buttons *') : null;
      if (!target) return;

      if (refreshDeliveryWindowForCheckout(state)) {
        e.preventDefault();
        e.stopImmediatePropagation();
        alert('\u7de0\u5207\u6642\u523b\u307e\u305f\u306f\u914d\u9001\u6761\u4ef6\u304c\u5909\u308f\u3063\u305f\u305f\u3081\u3001\u914d\u9001\u5e0c\u671b\u65e5\u6642\u3092\u518d\u5ea6\u9078\u629e\u3057\u3066\u304f\u3060\u3055\u3044\u3002');
        return;
      }

      if (state.pendingDeliverySync) {
        e.preventDefault();
        e.stopImmediatePropagation();
        alert('\u914d\u9001\u5e0c\u671b\u3092\u4fdd\u5b58\u4e2d\u3067\u3059\u3002\u5b8c\u4e86\u5f8c\u306b\u3082\u3046\u4e00\u5ea6\u304a\u9032\u307f\u304f\u3060\u3055\u3044\u3002');
        return;
      }

      if (isDeliveryDateOutOfRange(state)) {
        e.preventDefault();
        e.stopImmediatePropagation();
        clearInvalidDeliverySelection(state);
        alert('\u914d\u9001\u5e0c\u671b\u65e5\u304c\u6700\u77ed\u914d\u9001\u53ef\u80fd\u65e5\u3088\u308a\u524d\u306e\u305f\u3081\u3001\u914d\u9001\u5e0c\u671b\u3092\u30ea\u30bb\u30c3\u30c8\u3057\u307e\u3057\u305f\u3002\u518d\u5ea6\u9078\u629e\u3057\u3066\u304f\u3060\u3055\u3044\u3002');
        return;
      }

      var dateVal = state.dateInput ? state.dateInput.value : '';
      var timeVal = state.timeSelect ? state.timeSelect.value : '';
      if (state.deliverySyncError || state.lastSyncedDelivery !== deliveryStateSignature(dateVal, timeVal)) {
        e.preventDefault();
        e.stopImmediatePropagation();
        queueDeliveryStateSync(state, dateVal, timeVal);
        alert('\u914d\u9001\u5e0c\u671b\u3092\u4fdd\u5b58\u3057\u307e\u3059\u3002\u5b8c\u4e86\u5f8c\u306b\u3082\u3046\u4e00\u5ea6\u304a\u9032\u307f\u304f\u3060\u3055\u3044\u3002');
      }
    }, true);
  }

  function getCartAttributeKey(input) {
    var name = input && input.getAttribute('name');
    var match = name && name.match(/^attributes\[(.+)\]$/);
    return match ? match[1] : '';
  }

  function setTimeSlotAvailability(timeSelect, allowedSlots) {
    if (!timeSelect) return;
    var allowed = {};
    for (var i = 0; i < allowedSlots.length; i++) {
      allowed[allowedSlots[i]] = true;
    }
    for (var j = 0; j < timeSelect.options.length; j++) {
      var option = timeSelect.options[j];
      if (!option.value) {
        option.disabled = false;
      } else {
        option.disabled = !allowed[option.value];
      }
    }
  }

  function isAllTimeSlots(allowedSlots) {
    if (!Array.isArray(allowedSlots) || allowedSlots.length !== ALL_TIME_SLOTS.length) return false;
    for (var i = 0; i < ALL_TIME_SLOTS.length; i++) {
      if (allowedSlots.indexOf(ALL_TIME_SLOTS[i]) === -1) return false;
    }
    return true;
  }

  function ensureMinDateTimeNotice(timeSelect) {
    if (!timeSelect) return null;
    var field = timeSelect.closest ? timeSelect.closest('.kpw-delivery__field') : timeSelect.parentNode;
    if (!field) return null;
    var notice = field.querySelector('.kpw-delivery__time-notice');
    if (notice) return notice;

    notice = document.createElement('p');
    notice.className = 'kpw-delivery__hint kpw-delivery__time-notice';
    notice.textContent = '※この地域では、最短お届け日は午後以降の時間帯のみ指定できます。';
    notice.hidden = true;
    field.appendChild(notice);
    return notice;
  }

  function updateMinDateTimeNotice(dateStr, state, allowedSlots, timeSelect) {
    var notice = state.timeNoticeEl || ensureMinDateTimeNotice(timeSelect);
    if (!notice) return;
    state.timeNoticeEl = notice;

    var isMinDate = !!(dateStr && state.minDateStr && dateStr === state.minDateStr);
    notice.hidden = !(isMinDate && !isAllTimeSlots(allowedSlots));
  }

  function allowedTimeSlotsForDate(dateStr, minDateStr, rule) {
    return dateStr && minDateStr && dateStr === minDateStr ? normalizeSlots(rule) : ALL_TIME_SLOTS.slice();
  }

  function updateTimeSlots(dateStr, state, timeSelect, timeAttrKey) {
    if (!timeSelect || !state.rule) return;
    var allowedSlots = allowedTimeSlotsForDate(dateStr, state.minDateStr, state.rule);
    setTimeSlotAvailability(timeSelect, allowedSlots);
    updateMinDateTimeNotice(dateStr, state, allowedSlots, timeSelect);

    if (timeSelect.value) {
      var selected = timeSelect.options[timeSelect.selectedIndex];
      if (selected && selected.disabled) {
        timeSelect.value = '';
        if (timeAttrKey) saveCartAttribute(timeAttrKey, '');
      }
    }
  }

  function buildNoteDeliverySection(currentNote, dateVal, timeVal) {
    var clean = (currentNote || '').replace(/(?:\r?\n)?----\r?\n配達希望日：[^\r\n]*(?:\r?\n時間帯：[^\r\n]*)?\s*$/, '');
    clean = clean.replace(/\s+$/, '');

    if (!dateVal) return clean;

    var section = '----\n配達希望日：' + dateVal;
    if (timeVal) section += '\n時間帯：' + timeVal;

    return clean ? clean + '\n' + section : section;
  }

  function deliveryStateSignature(dateVal, timeVal) {
    return (dateVal || '') + '\n' + (timeVal || '');
  }

  function saveCartDeliveryState(state, dateVal, timeVal) {
    if (typeof fetch !== 'function') return Promise.resolve();

    return fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('cart_fetch_failed');
      return response.json();
    }).then(function (cart) {
      var attributes = {};
      if (state.dateAttrKey) attributes[state.dateAttrKey] = dateVal || '';
      if (state.timeAttrKey) attributes[state.timeAttrKey] = dateVal ? (timeVal || '') : '';

      var noteEl = state.form && state.form.querySelector('[name="note"]');
      var currentNote = noteEl ? noteEl.value : (cart.note || '');
      var nextNote = buildNoteDeliverySection(currentNote, dateVal, dateVal ? timeVal : '');
      var cartAttributes = cart.attributes || {};
      var attributesMatch = (!state.dateAttrKey || (cartAttributes[state.dateAttrKey] || '') === attributes[state.dateAttrKey]) &&
        (!state.timeAttrKey || (cartAttributes[state.timeAttrKey] || '') === attributes[state.timeAttrKey]);

      if (attributesMatch && (cart.note || '') === nextNote) {
        if (state.form) setNoteOnForm(state.form, nextNote);
        return;
      }

      return fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: attributes, note: nextNote })
      }).then(function (response) {
        if (!response.ok) throw new Error('cart_update_failed');
        if (state.form) setNoteOnForm(state.form, nextNote);
      });
    });
  }

  function queueDeliveryStateSync(state, dateVal, timeVal) {
    var signature = deliveryStateSignature(dateVal, dateVal ? timeVal : '');
    var previous = state.deliverySyncChain || Promise.resolve();
    var sync = previous.catch(function () {}).then(function () {
      return saveCartDeliveryState(state, dateVal, dateVal ? timeVal : '');
    }).then(function () {
      state.lastSyncedDelivery = signature;
      state.deliverySyncError = null;
      return true;
    }).catch(function (error) {
      state.deliverySyncError = error;
      return false;
    });

    state.deliverySyncChain = sync;
    state.pendingDeliverySync = sync;
    sync.then(function () {
      if (state.pendingDeliverySync === sync) state.pendingDeliverySync = null;
    });
    return sync;
  }

  function injectNoteToForm(form, dateVal, timeVal) {
    var noteEl = form.querySelector('[name="note"]');
    if (!noteEl) {
      noteEl = document.createElement('input');
      noteEl.type = 'hidden';
      noteEl.name = 'note';
      form.appendChild(noteEl);
    }
    noteEl.value = buildNoteDeliverySection(noteEl.value || '', dateVal, timeVal);
  }

  function setNoteOnForm(form, note) {
    var noteEl = form.querySelector('[name="note"]');
    if (!noteEl) {
      noteEl = document.createElement('input');
      noteEl.type = 'hidden';
      noteEl.name = 'note';
      form.appendChild(noteEl);
    }
    noteEl.value = note;
  }

  function applyDeliveryWindow(container, leadtimeData, state) {
    var dateInput = state.dateInput;
    var zipInput = state.zipInput;
    var timeSelect = state.timeSelect;
    var hintEl = state.hintEl;
    var pcode = container.getAttribute('data-province-code') || '';
    var zip = zipInput ? zipInput.value : '';
    var rule = resolveDeliveryRule(zip, pcode, leadtimeData, true);
    var now = getJSTNow();
    var minDate = calcArrivalDate(calcShipDate(now), rule.lead_days);
    var maxDate = new Date(minDate);
    maxDate.setDate(maxDate.getDate() + CONFIG.maxDaysAfterMin);

    state.rule = rule;
    state.minDate = minDate;
    state.maxDate = maxDate;
    state.minDateStr = toInputVal(minDate);
    state.maxDateStr = toInputVal(maxDate);

    dateInput.min = state.minDateStr;
    dateInput.max = state.maxDateStr;

    if (hintEl) {
      hintEl.textContent = formatJP(minDate) + '〜' + formatJP(maxDate) + ' の間でお選びいただけます（最短お届け可能日から' + CONFIG.maxDaysAfterMin + '日以内・任意）';
    }

    if (dateInput.value && (dateInput.value < state.minDateStr || dateInput.value > state.maxDateStr)) {
      clearInvalidDeliverySelection(state);
    }

    updateTimeSlots(dateInput.value, state, timeSelect, state.timeAttrKey);
  }

  function initDeliveryInstance(container) {
    var dateInput = container.querySelector('.kpw-delivery__date');
    var zipInput = container.querySelector('.kpw-delivery__zip');
    var timeSelect = container.querySelector('.kpw-delivery__time');
    var hintEl = container.querySelector('.kpw-delivery__date-hint');
    if (!dateInput) return;

    var form = container.closest('form');
    var state = {
      container: container,
      dateInput: dateInput,
      zipInput: zipInput,
      timeSelect: timeSelect,
      hintEl: hintEl,
      dateAttrKey: getCartAttributeKey(dateInput),
      zipAttrKey: getCartAttributeKey(zipInput),
      timeAttrKey: getCartAttributeKey(timeSelect),
      timeNoticeEl: null,
      minDateStr: '',
      maxDateStr: '',
      rule: null,
      leadtimeData: null,
      form: form,
      pendingDeliverySync: null,
      deliverySyncChain: null,
      deliverySyncError: null,
      lastSyncedDelivery: null
    };

    if (zipInput && zipInput.value) {
      zipInput.value = normalizeZip(zipInput.value);
    }

    applyDeliveryWindow(container, null, state);

    var leadtimeUrl = container.getAttribute('data-leadtime-url') || '';
    loadLeadtimeData(leadtimeUrl).then(function (data) {
      state.leadtimeData = data;
      applyDeliveryWindow(container, data, state);
    });

    if (zipInput) {
      zipInput.addEventListener('input', function () {
        var normalized = normalizeZip(this.value);
        if (normalized.length === 7 || normalized.length === 0) {
          applyDeliveryWindow(container, state.leadtimeData, state);
          if (state.zipAttrKey) saveCartAttribute(state.zipAttrKey, normalized);
        }
      });
      zipInput.addEventListener('change', function () {
        var normalized = normalizeZip(this.value);
        this.value = normalized;
        if (state.zipAttrKey) saveCartAttribute(state.zipAttrKey, normalized);
        applyDeliveryWindow(container, state.leadtimeData, state);
      });
      zipInput.addEventListener('blur', function () {
        var normalized = normalizeZip(this.value);
        this.value = normalized;
        if (state.zipAttrKey) saveCartAttribute(state.zipAttrKey, normalized);
        applyDeliveryWindow(container, state.leadtimeData, state);
      });
    }

    dateInput.addEventListener('change', function () {
      var val = this.value;

      if (val && ((state.minDateStr && val < state.minDateStr) || (state.maxDateStr && val > state.maxDateStr))) {
        clearInvalidDeliverySelection(state);
        this.setCustomValidity('');
        return;
      }

      if (!val) {
        this.setCustomValidity('');
        if (hintEl) hintEl.textContent = formatJP(state.minDate) + '〜' + formatJP(state.maxDate) + ' の間でお選びいただけます（最短お届け可能日から' + CONFIG.maxDaysAfterMin + '日以内・任意）';
        updateTimeSlots('', state, timeSelect, state.timeAttrKey);
        queueDeliveryStateSync(state, '', '');
        return;
      }

      var parts = val.split('-');
      var sel = new Date(+parts[0], +parts[1] - 1, +parts[2]);
      var msg = isClosedDate(sel) ? 'その日は定休日のためお届けできません。' : '';
      this.setCustomValidity(msg);
      if (hintEl) hintEl.textContent = msg || '';

      updateTimeSlots(val, state, timeSelect, state.timeAttrKey);
      queueDeliveryStateSync(state, val, timeSelect ? timeSelect.value : '');
    });

    if (timeSelect) {
      timeSelect.addEventListener('change', function () {
        queueDeliveryStateSync(state, dateInput.value, this.value);
      });
    }

    installCheckoutGuard(form, state);
    queueDeliveryStateSync(state, dateInput.value, timeSelect ? timeSelect.value : '');
    window.addEventListener('pageshow', function () {
      refreshDeliveryWindowForCheckout(state);
    });
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) refreshDeliveryWindowForCheckout(state);
    });
    if (form && !form.dataset.kpwDeliveryValidated) {
      form.dataset.kpwDeliveryValidated = '1';
      form.addEventListener('submit', function (e) {
        if (refreshDeliveryWindowForCheckout(state)) {
          alert('\u7de0\u5207\u6642\u523b\u307e\u305f\u306f\u914d\u9001\u6761\u4ef6\u304c\u5909\u308f\u3063\u305f\u305f\u3081\u3001\u914d\u9001\u5e0c\u671b\u65e5\u6642\u3092\u518d\u5ea6\u9078\u629e\u3057\u3066\u304f\u3060\u3055\u3044\u3002');
          e.preventDefault();
          return;
        }
        if (state.pendingDeliverySync) {
          e.preventDefault();
          return;
        }
        if (!dateInput.value) {
          injectNoteToForm(form, '', '');
          return;
        }
        if (dateInput.value < state.minDateStr) {
          alert('配達希望日が正しくありません。' + formatJP(state.minDate) + ' 以降をお選びください。');
          e.preventDefault();
          return;
        }
        if (dateInput.value > state.maxDateStr) {
          alert('配達希望日は' + formatJP(state.minDate) + 'から' + CONFIG.maxDaysAfterMin + '日以内をお選びください。');
          e.preventDefault();
          return;
        }
        injectNoteToForm(form, dateInput.value, timeSelect ? timeSelect.value : '');
      }, true);
    }
  }

  function initAllDeliveryOptions() {
    var containers = document.querySelectorAll('[data-kpw-delivery]');
    for (var i = 0; i < containers.length; i++) {
      initDeliveryInstance(containers[i]);
    }
  }

  function init() {
    initShippingEstimate();
    initAllDeliveryOptions();
  }

  if (typeof window !== 'undefined' && window.__KPW_SHIPPING_TEST__) {
    window.__KPWShippingTest = {
      normalizeZip: normalizeZip,
      normalizeProvinceCode: normalizeProvinceCode,
      getTransitDays: getTransitDays,
      resolveDeliveryRule: resolveDeliveryRule,
      allowedTimeSlotsForDate: allowedTimeSlotsForDate,
      calcShipDate: calcShipDate,
      calcArrivalDate: calcArrivalDate,
      toInputVal: toInputVal,
      formatJP: formatJP,
      buildNoteDeliverySection: buildNoteDeliverySection,
      deliveryStateSignature: deliveryStateSignature,
      saveCartDeliveryState: saveCartDeliveryState,
      queueDeliveryStateSync: queueDeliveryStateSync,
      refreshDeliveryWindowForCheckout: refreshDeliveryWindowForCheckout,
      installCheckoutGuard: installCheckoutGuard
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
